import React from "react";
import { Link } from "react-router-dom";
import "./BlogCard.scss";
import { urlForImage } from "../../sanity/image";

const BlogCard = ({ blog }) => {
  const wordsPerMinute = 200;
  // Calculate estimated reading time
  const contentWords = blog.description.split(" ").length;
  const readingTime = Math.ceil(contentWords / wordsPerMinute);

  const shortenedDescription =
    blog.description.length > 100
      ? blog.description.substring(0, 100) + `... (${readingTime} min read)`
      : blog.description;

  return (
    <Link className="card" to={`/blog/${blog.slug.current}`} key={blog._id}>
      <div className="blogs__container-card">
        <div className="blogs__container-card-img">
          <img src={urlForImage(blog.mainImage).url()} alt="blog" />
        </div>

        <div className="blogs__container-card-content">
          <div className="card__content-text">
            <h2>{blog.title}</h2>
            <p>{shortenedDescription}</p>
          </div>

          <div className="card__content-footer">
            <div className="card__content-footer__author">
              <div className="footer__author-img">
                {blog?.author?.image && (
                  <img
                    src={urlForImage(blog?.author.image).url()}
                    alt="author"
                  />
                )}
                {/* <img src={Author} alt="author" /> */}
              </div>

              <div className="footer__author-text">
                <h3 className="author-name">{blog.author.name}</h3>
                <p className="author-date">
                  {new Date(blog.publishedAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
            </div>

            <Link
              className="footer-read"
              to={`/blogs/${blog.slug.current}`}
              key={blog._id}
            >
              <button className="read-more"> Read More</button>
            </Link>
          </div>
        </div>
      </div>
    </Link>
  );
};
export default BlogCard;
